<div>
    <section class="elementor-38 elementor-section elementor-top-section elementor-element elementor-element-bc734fd elementor-section-full_width animated-slow elementor-section-height-default elementor-section-height-default" data-id="bc734fd" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;animation&quot;:&quot;none&quot;}">
        <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6262074" data-id="6262074" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
                <name-and-mobile-number-form v-if="showNameAndMobileNumberForm"
                     @canContinue="continueToNextStep">
                </name-and-mobile-number-form>
                
                <otp-form
                    v-if="showOtpForm"
                    :instanceId="instanceId"
                    @canContinue="continueToNextStep"></otp-form>
                
                <customer-details-form
                    v-if="showCustomerDetailsForm"
                    :instanceId="instanceId"
                    @canContinue="continueToNextStep"></customer-details-form>

                <sign-up-success
                        v-if="showSignUpSuccess"></sign-up-success>
            </div>
        </div>
    </section>
</div>
